export default __webpack_public_path__ + "static/media/enviroment_person_icon.b46145b2.png";